<template>
  <div :class="['grow shrink basis-0', cardClass, { 'border-[#ff78b2]': highlighted, 'border-white/10': !highlighted, 'hover:border-[#52B4FF]': !highlighted, 'hover:border-[#ff78b2]': highlighted }]" class="pricing-card-root rounded-[20px] border flex-col justify-start items-start inline-flex relative w-full h-full hover:scale-101 hover:shadow-[0_0_30px_rgba(45,212,191,0.1)] transition-all duration-200 overflow-hidden group">
    <div v-if="highlighted" class="self-stretch h-14 flex-col justify-start items-start gap-3 flex overflow-hidden">
      <div class="self-stretch h-14 rounded-lg flex-col justify-center items-center gap-2 flex">
        <div class="self-stretch px-8 py-4 bg-[#ff78b2] justify-center items-center gap-2 inline-flex">
          <div class="text-black/90 text-base font-medium font-['Inter'] leading-normal uppercase">{{ recommended ? $t('recommended') : $t('current')}}</div>
        </div>
      </div>
    </div>
    <div :class="['self-stretch', { 'rounded-t-[0px]': highlighted }]" class="p-6 bg-white/5 backdrop-blur-2xl flex-col justify-start items-start gap-6 flex min-h-[406px] h-full w-full rounded-[20px]">
      <div class="self-stretch flex-col justify-start items-start gap-6 flex">
        <div class="self-stretch flex-col justify-start items-start flex">
          <div class="self-stretch justify-start items-start inline-flex">
            <div class="grow shrink basis-0 flex-col justify-start items-start inline-flex">
              <div v-if="isLoading" class="bg-gray-300 animate-pulse h-[38px] w-3/4 rounded"></div>
              <div v-else class="text-white text-3xl font-semibold font-['Inter'] leading-[38px]">{{ title }}</div>
            </div>
          </div>
          <div v-if="isLoading" class="bg-gray-300 animate-pulse h-[20px] w-full rounded mt-[8px]"></div>
          <div v-else class="w-full text-white/75 text-sm font-medium font-['Inter'] leading-tight mt-[8px]">{{ description }}</div>
          <div v-if="showPrice" class="h-[30px] flex-col justify-start items-start gap-4 inline-flex mt-[16px]">
            <div v-if="isLoading" class="bg-gray-300 animate-pulse h-[30px] w-1/2 rounded"></div>
            <div v-else class="self-stretch text-white text-[19px] font-semibold font-['Inter'] leading-[30px]">
              <!-- <span v-if="discountFromText" class="line-through">{{ discountFromText }}</span> -->
              {{ priceText }}
            </div>
          </div>
        </div>
      </div>
      <div class="self-stretch h-[0px] border border-white/10"></div>
      <div class="self-stretch flex-1 flex-col justify-start items-start gap-4 flex">
        <slot name="features"></slot>
      </div>
      <div class="self-stretch mt-auto pt-3 flex-col justify-start items-start gap-4 flex">
        <button v-if="!comingSoon" @click="onClick" :disabled="disabled" class=" hover:bg-[#52B4FF] self-stretch px-5 py-2.5 bg-[#52B4FF] rounded-xl justify-center items-center gap-2 inline-flex overflow-hidden disabled:bg-[#ffffff0d] disabled:text-white text-black text-base font-medium font-['Inter'] leading-normal duration-160" :class="{ 'cursor-not-allowed': disabled, 'cursor-pointer': !disabled }">
          {{ buttonText }}
        </button>
        <a href="javascript:;" v-else class="text-[#52B4FF] text-center justify-center flex w-full items-center self-stretch px-5 py-2.5" @click="fallbackFunc">{{ $t('coming_soon') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PricingCard',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    discountFromText: {
      type: String,
      required: false
    },
    priceText: {
      type: String,
      required: true
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      required: true
    },
    features: {
      type: Array,
      required: true
    },
    recommended: {
      type: Boolean,
      default: false
    },
    current: {
      type: Boolean,
      default: false,
    },
    cardClass: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      required: true
    },
    fallbackFunc: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    comingSoon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    highlighted() {
      return this.recommended || this.current
    }
  }
}
</script>

<style scoped>
/* Add any additional styles if needed */
</style>
